import { Union, Record } from "./fable_modules/fable-library-js.4.24.0/Types.js";
import { UpdatedUser, User as User_1, S3UploadFile, Workplace_$reflection, Region_$reflection, User_$reflection } from "./Shared/SharedModels.jsx";
import { union_type, class_type, string_type, record_type, bool_type, array_type, option_type } from "./fable_modules/fable-library-js.4.24.0/Reflection.js";
import { createElement } from "react";
import React from "react";
import { ContextMsg, useCtx } from "./Context.jsx";
import { reactApi } from "./fable_modules/Feliz.2.9.0/Interop.fs.js";
import { Title3, CardFooter, Table, TableBody, TableCellLayout, TableCell, TableRow, Divider, Avatar, Title1, CardHeader, Card, Switch, Option, Dropdown, Label, Input, Field, DialogSurface, DialogBody, Text as Text$, Spinner, DialogActions, tokens, Image, DialogContent, DialogTitle, Button, DialogTrigger, Dialog } from "@fluentui/react-components";
import { equals, createObj } from "./fable_modules/fable-library-js.4.24.0/Util.js";
import { toArray, tryHead, take, length, empty, singleton, append, delay, toList } from "./fable_modules/fable-library-js.4.24.0/Seq.js";
import { PersonPasskeyRegular, BriefcaseRegular, MapRegular, PersonRegular, SaveRegular, DismissRegular, ImageAddRegular, EditRegular } from "@fluentui/react-icons";
import { reactApi as reactApi_1 } from "./fable_modules/Feliz.2.9.0/Interop.fs.js";
import { singleton as singleton_1, ofArray } from "./fable_modules/fable-library-js.4.24.0/List.js";
import { PromiseBuilder__Delay_62FBFDE1, PromiseBuilder__Run_212F1D4B } from "./fable_modules/Fable.Promise.3.2.0/Promise.fs.js";
import { promise } from "./fable_modules/Fable.Promise.3.2.0/PromiseImpl.fs.js";
import { startAsPromise } from "./fable_modules/fable-library-js.4.24.0/Async.js";
import { Browser_Types_File__File_ReadAsByteArray } from "./fable_modules/Fable.Remoting.Client.7.35.0/Extensions.fs.js";
import { Workplace as Workplace_1, Region, toastServerError, User } from "./ApiClient.jsx";
import { successToast, errorToast } from "./Toasts.jsx";
import { isValidName } from "./Shared/Validators.jsx";
import { isNullOrWhiteSpace } from "./fable_modules/fable-library-js.4.24.0/String.js";
import { defaultOf } from "./fable_modules/fable-library-js.4.24.0/Util.js";
import { bind, map, defaultArg } from "./fable_modules/fable-library-js.4.24.0/Option.js";
import { map as map_1, tryFind } from "./fable_modules/fable-library-js.4.24.0/Array.js";
import { useEffectOnce } from "./fable_modules/Feliz.2.9.0/Internal.fs.js";

class Model extends Record {
    constructor(User, Regions, Workplaces, IsFetchingUser, EditUserForm, ProfilePictureForm) {
        super();
        this.User = User;
        this.Regions = Regions;
        this.Workplaces = Workplaces;
        this.IsFetchingUser = IsFetchingUser;
        this.EditUserForm = EditUserForm;
        this.ProfilePictureForm = ProfilePictureForm;
    }
}

function Model_$reflection() {
    return record_type("UserProfile.Model", [], Model, () => [["User", option_type(User_$reflection())], ["Regions", array_type(Region_$reflection())], ["Workplaces", array_type(Workplace_$reflection())], ["IsFetchingUser", bool_type], ["EditUserForm", option_type(User_$reflection())], ["ProfilePictureForm", ProfilePictureModel_$reflection()]]);
}

class ProfilePictureModel extends Record {
    constructor(Image, File, IsSendingPicture) {
        super();
        this.Image = Image;
        this.File = File;
        this.IsSendingPicture = IsSendingPicture;
    }
}

function ProfilePictureModel_$reflection() {
    return record_type("UserProfile.ProfilePictureModel", [], ProfilePictureModel, () => [["Image", option_type(string_type)], ["File", option_type(class_type("Browser.Types.File"))], ["IsSendingPicture", bool_type]]);
}

class Msg extends Union {
    constructor(tag, fields) {
        super();
        this.tag = tag;
        this.fields = fields;
    }
    cases() {
        return ["UpdateUser", "UpdateRegions", "UpdateWorkplaces", "SetUserIsFetched", "UpdateForm", "ResetForm", "UpdateProfilePictureForm"];
    }
}

function Msg_$reflection() {
    return union_type("UserProfile.Msg", [], Msg, () => [[["Item", option_type(User_$reflection())]], [["Item", array_type(Region_$reflection())]], [["Item", array_type(Workplace_$reflection())]], [], [["Item", User_$reflection()]], [], [["Item", ProfilePictureModel_$reflection()]]]);
}

function update(model, msg) {
    switch (msg.tag) {
        case 1:
            return new Model(model.User, msg.fields[0], model.Workplaces, model.IsFetchingUser, model.EditUserForm, model.ProfilePictureForm);
        case 2:
            return new Model(model.User, model.Regions, msg.fields[0], model.IsFetchingUser, model.EditUserForm, model.ProfilePictureForm);
        case 3:
            return new Model(model.User, model.Regions, model.Workplaces, false, model.EditUserForm, model.ProfilePictureForm);
        case 4:
            return new Model(model.User, model.Regions, model.Workplaces, model.IsFetchingUser, msg.fields[0], model.ProfilePictureForm);
        case 5:
            return new Model(model.User, model.Regions, model.Workplaces, model.IsFetchingUser, model.User, model.ProfilePictureForm);
        case 6:
            return new Model(model.User, model.Regions, model.Workplaces, model.IsFetchingUser, model.EditUserForm, msg.fields[0]);
        default: {
            const user = msg.fields[0];
            return new Model(user, model.Regions, model.Workplaces, false, user, model.ProfilePictureForm);
        }
    }
}

function init() {
    return new Model(undefined, [], [], true, undefined, new ProfilePictureModel(undefined, undefined, false));
}

function EditPictureDialog(editPictureDialogInputProps) {
    let elems_5, el_4, el_2, props_50, props_48, el_6, el_16, elems_2, elems_1, el_30, elems_4, el_20, el_18, el_28, name_4, name_6, elemsToUse;
    const dispatch = editPictureDialogInputProps.dispatch;
    const model = editPictureDialogInputProps.model;
    const user = editPictureDialogInputProps.user;
    const setCtx = useCtx()[1];
    const patternInput_1 = reactApi.useState(false);
    const setIsOpen = patternInput_1[1];
    const el_32 = Dialog;
    return createElement(el_32, createObj(ofArray([["open", patternInput_1[0]], ["onOpenChange", (_arg, value_1_1) => {
        setIsOpen(value_1_1.open);
    }], (elems_5 = [(el_4 = DialogTrigger, createElement(el_4, {
        children: (el_2 = Button, createElement(el_2, createObj(toList(delay(() => append(singleton(["size", "small"]), delay(() => append(singleton(["style", {
            paddingLeft: 0,
        }]), delay(() => {
            let el;
            return append(singleton(["icon", (el = EditRegular, createElement(el, {}))]), delay(() => append(singleton(["appearance", "transparent"]), delay(() => ((user.ImageUrl == null) ? singleton(["children", "Legg til bilde"]) : singleton(["children", "Rediger bilde"]))))));
        }))))))))),
    })), (props_50 = singleton_1((props_48 = ofArray([(el_6 = DialogTitle, createElement(el_6, {
        children: "Rediger profilbilde",
    })), (el_16 = DialogContent, createElement(el_16, createObj(ofArray([["style", {
        display: "flex",
        flexDirection: "column",
        gap: 10 + "px ",
        alignItems: "center",
    }], (elems_2 = [createElement("input", {
        id: "image-select-input",
        type: "file",
        accept: "image/png, image/jpeg",
        onChange: (ev) => {
            const files = ev.target.files;
            if (!(files == null) && (files.length > 0)) {
                const f = files.item(0);
                const reader = new FileReader();
                reader.onload = ((_arg_1) => {
                    const matchValue = reader.result;
                    if (typeof matchValue === "string") {
                        const base64data = matchValue;
                        dispatch(new Msg(6, [new ProfilePictureModel(base64data, f, model.ProfilePictureForm.IsSendingPicture)]));
                    }
                });
                reader.readAsDataURL(f);
            }
        },
        style: {
            display: "none",
        },
    }), createElement("div", createObj(ofArray([["style", {
        display: "flex",
        alignItems: "center",
        flexDirection: "column",
    }], (elems_1 = toList(delay(() => {
        let el_8, el_14, elems, el_12;
        const matchValue_1 = model.ProfilePictureForm.Image;
        if (matchValue_1 != null) {
            const img = matchValue_1;
            return append(singleton((el_8 = Image, createElement(el_8, {
                shape: "circular",
                style: {
                    width: 250,
                    height: 250,
                },
                fit: "cover",
                src: img,
            }))), delay(() => {
                let el_10;
                return singleton((el_10 = Button, createElement(el_10, {
                    disabled: model.ProfilePictureForm.IsSendingPicture,
                    children: "Slett",
                    size: "small",
                    onClick: (_arg_2) => {
                        dispatch(new Msg(6, [new ProfilePictureModel(undefined, undefined, model.ProfilePictureForm.IsSendingPicture)]));
                    },
                    appearance: "transparent",
                })));
            }));
        }
        else {
            return singleton((el_14 = Button, createElement(el_14, createObj(ofArray([["onClick", (_arg_3) => {
                document.getElementById("image-select-input").click();
            }], ["shape", "circular"], ["style", {
                height: 250,
                width: 250,
                borderStyle: "dashed",
                borderColor: tokens.colorBrandBackgroundStatic,
                borderWidth: 1,
            }], (elems = [(el_12 = ImageAddRegular, createElement(el_12, {
                fontSize: 48,
                primaryFill: tokens.colorBrandForeground2,
            }))], ["children", reactApi_1.Children.toArray(Array.from(elems))])])))));
        }
    })), ["children", reactApi.Children.toArray(Array.from(elems_1))])])))], ["children", reactApi_1.Children.toArray(Array.from(elems_2))])])))), (el_30 = DialogActions, createElement(el_30, createObj(ofArray([["position", "end"], (elems_4 = [(el_20 = Button, createElement(el_20, {
        disabled: model.ProfilePictureForm.IsSendingPicture,
        icon: (el_18 = DismissRegular, createElement(el_18, {})),
        iconPosition: "before",
        children: "Avbryt",
        onClick: (_arg_4) => {
            dispatch(new Msg(6, [new ProfilePictureModel(undefined, undefined, false)]));
            setIsOpen(false);
        },
    })), (el_28 = Button, createElement(el_28, createObj(toList(delay(() => {
        let el_22;
        return append(!model.ProfilePictureForm.IsSendingPicture ? singleton(["icon", (el_22 = SaveRegular, createElement(el_22, {}))]) : empty(), delay(() => append(singleton(["appearance", "primary"]), delay(() => append(singleton(["iconPosition", "before"]), delay(() => append(singleton(["onClick", (_arg_5) => {
            let bind$0040_3;
            const matchValue_2 = model.ProfilePictureForm.File;
            if (matchValue_2 != null) {
                const f_1 = matchValue_2;
                dispatch(new Msg(6, [(bind$0040_3 = model.ProfilePictureForm, new ProfilePictureModel(bind$0040_3.Image, bind$0040_3.File, true))]));
                const pr_2 = PromiseBuilder__Run_212F1D4B(promise, PromiseBuilder__Delay_62FBFDE1(promise, () => (startAsPromise(Browser_Types_File__File_ReadAsByteArray(f_1)).then((_arg_6) => {
                    let MimeType;
                    let pr_1;
                    const pr = startAsPromise(User.UpdateProfilePicture((MimeType = f_1.type, new S3UploadFile(f_1.name, MimeType, _arg_6))));
                    pr_1 = (pr.then((res) => {
                        let bind$0040_6, bind$0040_5;
                        if (res.tag === 1) {
                            if (res.fields[0].tag === 1) {
                                errorToast(setCtx, "updateProfilePicS3Error", "Kunne ikke laste opp bilde", "", undefined);
                                dispatch(new Msg(6, [(bind$0040_6 = model.ProfilePictureForm, new ProfilePictureModel(bind$0040_6.Image, bind$0040_6.File, false))]));
                            }
                            else {
                                errorToast(setCtx, "updateProfilePicNotFoundError", "Kunne ikke laste opp bilde", "Fant ikke bruker", undefined);
                                dispatch(new Msg(6, [(bind$0040_5 = model.ProfilePictureForm, new ProfilePictureModel(bind$0040_5.Image, bind$0040_5.File, false))]));
                            }
                        }
                        else {
                            successToast(setCtx, `addProfilePic${user.Id}Success`, "Profilbilde oppdatert", "");
                            const newUserObject = new User_1(user.Id, user.KeycloakId, user.FirstName, user.LastName, user.Enabled, user.IsAdmin, res.fields[0], user.Workplace, user.Inserted);
                            dispatch(new Msg(0, [newUserObject]));
                            setCtx(new ContextMsg(2, [newUserObject]));
                            dispatch(new Msg(6, [new ProfilePictureModel(undefined, undefined, false)]));
                            setIsOpen(false);
                        }
                    }));
                    void (pr_1.catch((ex) => {
                        let bind$0040_7;
                        dispatch(new Msg(6, [(bind$0040_7 = model.ProfilePictureForm, new ProfilePictureModel(bind$0040_7.Image, bind$0040_7.File, false))]));
                        toastServerError(setCtx, ex);
                    }));
                    return Promise.resolve();
                }))));
                void pr_2;
            }
        }]), delay(() => append(singleton(["disabled", (((user.ImageUrl != null) && (model.ProfilePictureForm.File == null)) ? true : ((user.ImageUrl == null) && (model.ProfilePictureForm.File == null))) ? true : model.ProfilePictureForm.IsSendingPicture]), delay(() => {
            let elems_3;
            return singleton((elems_3 = toList(delay(() => {
                let el_24, el_26;
                return model.ProfilePictureForm.IsSendingPicture ? singleton((el_24 = Spinner, createElement(el_24, {
                    size: "tiny",
                }))) : singleton((el_26 = Text$, createElement(el_26, {
                    children: "Last opp",
                })));
            })), ["children", reactApi_1.Children.toArray(Array.from(elems_3))]));
        }))))))))));
    })))))], ["children", reactApi_1.Children.toArray(Array.from(elems_4))])]))))]), (name_4 = DialogBody, createElement(name_4, {
        children: reactApi.Children.toArray(Array.from(props_48)),
    })))), (name_6 = DialogSurface, createElement(name_6, {
        children: reactApi.Children.toArray(Array.from(props_50)),
    })))], (elemsToUse = ((length(elems_5) <= 2) ? elems_5 : take(2, elems_5)), ["children", reactApi_1.Children.toArray(elemsToUse)]))])));
}

function EditUserDialog(editUserDialogInputProps) {
    let elems_12, el_4, el_2, el, props_76, props_74, el_6, el_40, elems_10, el_50, elems_11, el_44, el_42, el_48, el_46, name_13, name_15, elemsToUse;
    const dispatch = editUserDialogInputProps.dispatch;
    const model = editUserDialogInputProps.model;
    const form = editUserDialogInputProps.form;
    const patternInput = useCtx();
    const setCtx = patternInput[1];
    const ctx = patternInput[0];
    const patternInput_1 = reactApi.useState(false);
    const setIsOpen = patternInput_1[1];
    const el_52 = Dialog;
    return createElement(el_52, createObj(ofArray([["open", patternInput_1[0]], ["onOpenChange", (_arg_1, value_1_1) => {
        setIsOpen(value_1_1.open);
    }], (elems_12 = [(el_4 = DialogTrigger, createElement(el_4, {
        children: (el_2 = Button, createElement(el_2, {
            icon: (el = EditRegular, createElement(el, {})),
            iconPosition: "before",
            children: "Rediger",
            disabled: (model.EditUserForm == null) ? true : ((ctx.User.Id !== form.Id) && !ctx.User.IsAdmin),
        })),
    })), (props_76 = singleton_1((props_74 = ofArray([(el_6 = DialogTitle, createElement(el_6, {
        children: "Rediger profilinstillinger",
    })), (el_40 = DialogContent, createElement(el_40, createObj(ofArray([["style", {
        display: "flex",
        flexDirection: "column",
        gap: 10 + "px ",
        alignItems: "start",
    }], (elems_10 = toList(delay(() => {
        let elems_1, el_11;
        return append(singleton(createElement("div", createObj(ofArray([["style", {
            height: 70,
        }], (elems_1 = [(el_11 = Field, createElement(el_11, createObj(toList(delay(() => append(singleton(["label", "Fornavn"]), delay(() => append(!isValidName(form.FirstName) ? append(isNullOrWhiteSpace(form.FirstName) ? singleton(["validationMessage", "Navn kan ikke være tomt"]) : singleton(["validationMessage", "Navn kan ikke inneholde tall/tegn"]), delay(() => singleton(["validationState", "error"]))) : empty(), delay(() => {
            let matchValue, el_8;
            return singleton(["children", (matchValue = tryHead([(el_8 = Input, createElement(el_8, {
                value: form.FirstName,
                onChange: (_arg_2, value_1_10) => {
                    dispatch(new Msg(4, [new User_1(form.Id, form.KeycloakId, value_1_10.value, form.LastName, form.Enabled, form.IsAdmin, form.ImageUrl, form.Workplace, form.Inserted)]));
                },
            }))]), (matchValue == null) ? defaultOf() : matchValue)]);
        })))))))))], ["children", reactApi.Children.toArray(Array.from(elems_1))])])))), delay(() => {
            let elems_3, el_16;
            return append(singleton(createElement("div", createObj(ofArray([["style", {
                height: 70,
            }], (elems_3 = [(el_16 = Field, createElement(el_16, createObj(toList(delay(() => append(singleton(["label", "Etternavn"]), delay(() => append(!isValidName(form.LastName) ? append(isNullOrWhiteSpace(form.LastName) ? singleton(["validationMessage", "Navn kan ikke være tomt"]) : singleton(["validationMessage", "Navn kan ikke inneholde tall/tegn"]), delay(() => singleton(["validationState", "error"]))) : empty(), delay(() => {
                let matchValue_1, el_13;
                return singleton(["children", (matchValue_1 = tryHead([(el_13 = Input, createElement(el_13, {
                    value: form.LastName,
                    onChange: (_arg_3, value_1_15) => {
                        dispatch(new Msg(4, [new User_1(form.Id, form.KeycloakId, form.FirstName, value_1_15.value, form.Enabled, form.IsAdmin, form.ImageUrl, form.Workplace, form.Inserted)]));
                    },
                }))]), (matchValue_1 == null) ? defaultOf() : matchValue_1)]);
            })))))))))], ["children", reactApi.Children.toArray(Array.from(elems_3))])])))), delay(() => {
                let elems_7, el_18, elems_6, el_24, elems_5, el_28, el_26;
                return append(singleton(createElement("div", createObj(ofArray([["style", {
                    display: "flex",
                    flexDirection: "column",
                }], (elems_7 = [(el_18 = Label, createElement(el_18, {
                    children: "Arbeidsplass",
                })), createElement("div", createObj(ofArray([["style", {
                    display: "flex",
                    gap: 5 + "px ",
                }], (elems_6 = [(el_24 = Dropdown, createElement(el_24, createObj(ofArray([["style", {
                    minWidth: 200,
                }], ["value", defaultArg(map((_arg_4) => _arg_4.Name, form.Workplace), "Ingen valgt")], ["selectedOptions", toArray([defaultArg(map((_arg_5) => _arg_5.Name, form.Workplace), "Ingen valgt")])], ["onOptionSelect", (_arg_6, value_1_19) => {
                    dispatch(new Msg(4, [new User_1(form.Id, form.KeycloakId, form.FirstName, form.LastName, form.Enabled, form.IsAdmin, form.ImageUrl, bind((name_6) => tryFind((w) => (w.Name === name_6), model.Workplaces), value_1_19.optionText), form.Inserted)]));
                }], (elems_5 = toList(delay(() => map_1((workplace) => {
                    let elems_4, el_20;
                    const el_22 = Option;
                    return createElement(el_22, createObj(ofArray([["text", workplace.Name], (elems_4 = [(el_20 = Text$, createElement(el_20, {
                        children: workplace.Name,
                    }))], ["children", reactApi_1.Children.toArray(Array.from(elems_4))])])));
                }, model.Workplaces))), ["children", reactApi_1.Children.toArray(Array.from(elems_5))])])))), (el_28 = Button, createElement(el_28, {
                    icon: (el_26 = DismissRegular, createElement(el_26, {})),
                    appearance: "transparent",
                    disabled: form.Workplace == null,
                    onClick: (_arg_7) => {
                        dispatch(new Msg(4, [new User_1(form.Id, form.KeycloakId, form.FirstName, form.LastName, form.Enabled, form.IsAdmin, form.ImageUrl, undefined, form.Inserted)]));
                    },
                }))], ["children", reactApi.Children.toArray(Array.from(elems_6))])])))], ["children", reactApi.Children.toArray(Array.from(elems_7))])])))), delay(() => {
                    let el_33;
                    return ctx.User.IsAdmin ? append(singleton((el_33 = Field, createElement(el_33, createObj(toList(delay(() => append(singleton(["label", "Administrator"]), delay(() => append((ctx.User.Id === form.Id) ? append(singleton(["validationMessage", "Kan ikke endres på egen konto"]), delay(() => singleton(["validationState", "warning"]))) : singleton(["validationState", "none"]), delay(() => {
                        let matchValue_2, el_30;
                        return singleton(["children", (matchValue_2 = tryHead([(el_30 = Switch, createElement(el_30, {
                            checked: form.IsAdmin,
                            disabled: ctx.User.Id === form.Id,
                            onChange: (_arg_8, value_1_27) => {
                                dispatch(new Msg(4, [new User_1(form.Id, form.KeycloakId, form.FirstName, form.LastName, form.Enabled, value_1_27.checked, form.ImageUrl, form.Workplace, form.Inserted)]));
                            },
                        }))]), (matchValue_2 == null) ? defaultOf() : matchValue_2)]);
                    })))))))))), delay(() => {
                        let el_38;
                        return singleton((el_38 = Field, createElement(el_38, createObj(toList(delay(() => append(singleton(["label", "Aktiv"]), delay(() => append((ctx.User.Id === form.Id) ? append(singleton(["validationMessage", "Kan ikke endres på egen konto"]), delay(() => singleton(["validationState", "warning"]))) : singleton(["validationState", "none"]), delay(() => {
                            let matchValue_3, el_35;
                            return singleton(["children", (matchValue_3 = tryHead([(el_35 = Switch, createElement(el_35, {
                                checked: form.Enabled,
                                disabled: ctx.User.Id === form.Id,
                                onChange: (_arg_9, value_1_32) => {
                                    dispatch(new Msg(4, [new User_1(form.Id, form.KeycloakId, form.FirstName, form.LastName, value_1_32.checked, form.IsAdmin, form.ImageUrl, form.Workplace, form.Inserted)]));
                                },
                            }))]), (matchValue_3 == null) ? defaultOf() : matchValue_3)]);
                        }))))))))));
                    })) : empty();
                }));
            }));
        }));
    })), ["children", reactApi_1.Children.toArray(Array.from(elems_10))])])))), (el_50 = DialogActions, createElement(el_50, createObj(ofArray([["position", "end"], (elems_11 = [(el_44 = Button, createElement(el_44, {
        icon: (el_42 = DismissRegular, createElement(el_42, {})),
        iconPosition: "before",
        children: "Avbryt",
        onClick: (_arg_10) => {
            dispatch(new Msg(5, []));
            setIsOpen(false);
        },
    })), (el_48 = Button, createElement(el_48, {
        icon: (el_46 = SaveRegular, createElement(el_46, {})),
        appearance: "primary",
        iconPosition: "before",
        onClick: (_arg_11) => {
            let pr_1;
            const pr = startAsPromise(User.UpdateUser(form.Id, new UpdatedUser(form.FirstName, form.LastName, form.Enabled, form.IsAdmin, map((_arg) => _arg.Id, form.Workplace))));
            pr_1 = (pr.then((res) => {
                if (res.tag === 1) {
                    switch (res.fields[0].tag) {
                        case 1: {
                            errorToast(setCtx, `updateUser${form.Id}WorkplaceNotFound`, "Kunne ikke oppdatere bruker", "Ugyldig arbeidsplass", undefined);
                            break;
                        }
                        case 2: {
                            errorToast(setCtx, `updateUser${form.Id}InvalidName`, "Kunne ikke oppdatere bruker", "Ugyldig navn", undefined);
                            break;
                        }
                        default:
                            errorToast(setCtx, `updateUser${form.Id}UserNotFound`, "Kunne ikke oppdatere bruker", "Ugyldig bruker", undefined);
                    }
                }
                else {
                    const newUser = res.fields[0];
                    setIsOpen(false);
                    dispatch(new Msg(0, [newUser]));
                    if (newUser.Id === ctx.User.Id) {
                        setCtx(new ContextMsg(2, [newUser]));
                    }
                }
                return res;
            }));
            void (pr_1.catch((ex) => {
                toastServerError(setCtx, ex);
            }));
        },
        disabled: (defaultArg(map((user) => equals(user, form), model.User), false) ? true : !isValidName(form.FirstName)) ? true : !isValidName(form.LastName),
        children: "Lagre endringer",
    }))], ["children", reactApi_1.Children.toArray(Array.from(elems_11))])]))))]), (name_13 = DialogBody, createElement(name_13, {
        children: reactApi.Children.toArray(Array.from(props_74)),
    })))), (name_15 = DialogSurface, createElement(name_15, {
        children: reactApi.Children.toArray(Array.from(props_76)),
    })))], (elemsToUse = ((length(elems_12) <= 2) ? elems_12 : take(2, elems_12)), ["children", reactApi_1.Children.toArray(elemsToUse)]))])));
}

export function AboutUser(aboutUserInputProps) {
    let elems_4, el_80, elems_3, el_8, elems, elems_1, el_6, el_10, props_111, props_109, name_10, name_12, el_78, elems_2;
    const userId = aboutUserInputProps.userId;
    const patternInput = useCtx();
    const setCtx = patternInput[1];
    const ctx = patternInput[0];
    let patternInput_1;
    const arg_1 = init();
    patternInput_1 = reactApi.useReducer(update, arg_1);
    const model_1 = patternInput_1[0];
    const dispatch = patternInput_1[1];
    useEffectOnce(() => {
        if (ctx.User.Id === userId) {
            dispatch(new Msg(0, [ctx.User]));
        }
        else {
            let pr_1;
            const pr = startAsPromise(User.GetUser(userId));
            pr_1 = (pr.then((res) => {
                if (res.tag === 1) {
                    dispatch(new Msg(3, []));
                }
                else {
                    dispatch(new Msg(0, [res.fields[0]]));
                }
                return res;
            }));
            void (pr_1.catch((ex) => {
                toastServerError(setCtx, ex);
            }));
        }
        let pr_3;
        const pr_2 = startAsPromise(Region.GetEnabledRegions());
        pr_3 = (pr_2.then((res_1) => {
            if (res_1.tag === 1) {
                errorToast(setCtx, "fetchRegionsError", "Kunne ikke hente regioner", "Noe gikk galt", undefined);
            }
            else {
                dispatch(new Msg(1, [res_1.fields[0]]));
            }
            return res_1;
        }));
        void (pr_3.catch((ex_1) => {
            toastServerError(setCtx, ex_1);
        }));
        let pr_5;
        const pr_4 = startAsPromise(Workplace_1.GetEnabledWorkplaces());
        pr_5 = (pr_4.then((res_2) => {
            if (res_2.tag === 1) {
                errorToast(setCtx, "fetchWorkplacesError", "Kunne ikke hente arbeidsplasser", "Noe gikk galt", undefined);
            }
            else {
                dispatch(new Msg(2, [res_2.fields[0]]));
            }
        }));
        void (pr_5.catch((ex_2) => {
            toastServerError(setCtx, ex_2);
        }));
    });
    const matchValue = model_1.User;
    if (matchValue != null) {
        const u_1 = matchValue;
        return createElement("div", createObj(ofArray([["style", {
            display: "flex",
            justifyContent: "center",
        }], (elems_4 = [(el_80 = Card, createElement(el_80, createObj(ofArray([["size", "large"], ["style", {
            maxWidth: 70 + "rem",
        }], (elems_3 = [(el_8 = CardHeader, createElement(el_8, {
            header: createElement("div", createObj(ofArray([["style", {
                alignItems: "flex-start",
                display: "flex",
                flexDirection: "column",
            }], (elems = toList(delay(() => {
                let el_4;
                return append(singleton((el_4 = Title1, createElement(el_4, {
                    weight: "semibold",
                    children: `${u_1.FirstName} ${u_1.LastName}`,
                }))), delay(() => ((userId === ctx.User.Id) ? singleton(createElement(EditPictureDialog, {
                    user: u_1,
                    model: model_1,
                    dispatch: dispatch,
                })) : empty())));
            })), ["children", reactApi.Children.toArray(Array.from(elems))])]))),
            image: createElement("div", createObj(ofArray([["style", {
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
            }], (elems_1 = [(el_6 = Avatar, createElement(el_6, {
                name: `${u_1.FirstName} ${u_1.LastName}`,
                size: 96,
                color: "cranberry",
                image: {
                    src: defaultArg(u_1.ImageUrl, ""),
                },
            }))], ["children", reactApi.Children.toArray(Array.from(elems_1))])]))),
        })), (el_10 = Divider, createElement(el_10, {})), (props_111 = singleton_1((props_109 = toList(delay(() => {
            let el_26, el_18, el_16, el_12, el_14, el_24, el_22, el_20;
            return append(singleton((el_26 = TableRow, createElement(el_26, {
                children: ofArray([(el_18 = TableCell, createElement(el_18, {
                    children: singleton_1((el_16 = TableCellLayout, createElement(el_16, {
                        media: (el_12 = PersonRegular, createElement(el_12, {})),
                        children: singleton_1((el_14 = Text$, createElement(el_14, {
                            children: "Navn",
                        }))),
                    }))),
                })), (el_24 = TableCell, createElement(el_24, {
                    children: singleton_1((el_22 = TableCellLayout, createElement(el_22, {
                        children: singleton_1((el_20 = Text$, createElement(el_20, {
                            children: `${u_1.FirstName} ${u_1.LastName}`,
                        }))),
                    }))),
                }))]),
            }))), delay(() => {
                let el_42, el_34, el_32, el_28, el_30, el_40, props_56, name_4;
                return append(singleton((el_42 = TableRow, createElement(el_42, {
                    children: ofArray([(el_34 = TableCell, createElement(el_34, {
                        children: singleton_1((el_32 = TableCellLayout, createElement(el_32, {
                            media: (el_28 = MapRegular, createElement(el_28, {})),
                            children: singleton_1((el_30 = Text$, createElement(el_30, {
                                children: "Region",
                            }))),
                        }))),
                    })), (el_40 = TableCell, createElement(el_40, {
                        children: singleton_1((props_56 = toList(delay(() => {
                            let el_38, el_36;
                            const matchValue_1 = u_1.Workplace;
                            return (matchValue_1 == null) ? singleton((el_38 = Text$, createElement(el_38, {
                                children: "-",
                            }))) : singleton((el_36 = Text$, createElement(el_36, {
                                children: `${matchValue_1.Region.Name}`,
                            })));
                        })), (name_4 = TableCellLayout, createElement(name_4, {
                            children: reactApi.Children.toArray(Array.from(props_56)),
                        })))),
                    }))]),
                }))), delay(() => {
                    let el_58, el_50, el_48, el_44, el_46, el_56, props_79, name_6;
                    return append(singleton((el_58 = TableRow, createElement(el_58, {
                        children: ofArray([(el_50 = TableCell, createElement(el_50, {
                            children: singleton_1((el_48 = TableCellLayout, createElement(el_48, {
                                media: (el_44 = BriefcaseRegular, createElement(el_44, {})),
                                children: singleton_1((el_46 = Text$, createElement(el_46, {
                                    children: "Arbeidsplass",
                                }))),
                            }))),
                        })), (el_56 = TableCell, createElement(el_56, {
                            children: singleton_1((props_79 = toList(delay(() => {
                                let el_54, el_52;
                                const matchValue_2 = u_1.Workplace;
                                return (matchValue_2 == null) ? singleton((el_54 = Text$, createElement(el_54, {
                                    children: "-",
                                }))) : singleton((el_52 = Text$, createElement(el_52, {
                                    children: `${matchValue_2.Name}`,
                                })));
                            })), (name_6 = TableCellLayout, createElement(name_6, {
                                children: reactApi.Children.toArray(Array.from(props_79)),
                            })))),
                        }))]),
                    }))), delay(() => {
                        let el_72, el_66, el_64, el_60, el_62, el_70, props_101, el_68, name_8;
                        return ctx.User.IsAdmin ? singleton((el_72 = TableRow, createElement(el_72, {
                            children: ofArray([(el_66 = TableCell, createElement(el_66, {
                                children: singleton_1((el_64 = TableCellLayout, createElement(el_64, {
                                    media: (el_60 = PersonPasskeyRegular, createElement(el_60, {})),
                                    children: singleton_1((el_62 = Text$, createElement(el_62, {
                                        children: "Administrator",
                                    }))),
                                }))),
                            })), (el_70 = TableCell, createElement(el_70, {
                                children: singleton_1((props_101 = singleton_1((el_68 = Text$, createElement(el_68, {
                                    children: u_1.IsAdmin ? "Ja" : "Nei",
                                }))), (name_8 = TableCellLayout, createElement(name_8, {
                                    children: reactApi.Children.toArray(Array.from(props_101)),
                                })))),
                            }))]),
                        }))) : empty();
                    }));
                }));
            }));
        })), (name_10 = TableBody, createElement(name_10, {
            children: reactApi.Children.toArray(Array.from(props_109)),
        })))), (name_12 = Table, createElement(name_12, {
            children: reactApi.Children.toArray(Array.from(props_111)),
        }))), (el_78 = CardFooter, createElement(el_78, createObj(ofArray([["style", {
            justifyContent: "end",
        }], (elems_2 = toList(delay(() => {
            let el_76, el_74;
            const matchValue_3 = model_1.EditUserForm;
            if (matchValue_3 != null) {
                const form = matchValue_3;
                return singleton(createElement(EditUserDialog, {
                    form: form,
                    model: model_1,
                    dispatch: dispatch,
                }));
            }
            else {
                return singleton((el_76 = Button, createElement(el_76, {
                    icon: (el_74 = EditRegular, createElement(el_74, {})),
                    iconPosition: "before",
                    children: "Rediger",
                    disabled: true,
                })));
            }
        })), ["children", reactApi_1.Children.toArray(Array.from(elems_2))])]))))], ["children", reactApi_1.Children.toArray(Array.from(elems_3))])]))))], ["children", reactApi.Children.toArray(Array.from(elems_4))])])));
    }
    else if (model_1.IsFetchingUser) {
        const el = Spinner;
        return createElement(el, {});
    }
    else {
        const el_2 = Title3;
        return createElement(el_2, {
            children: "Denne brukeren finnes ikke",
        });
    }
}

//# sourceMappingURL=UserProfile.jsx.map
